/**
 * Which environment is this? Three predicates, and nothing else — this module
 * imports NOTHING.
 *
 * They used to live in `helpers/featureFlags.js`, which imports `UserStore`.
 * `UserStore.isInventoryPilot` now has to ask "are we on production?" (the
 * pilot allowlist is a non-prod affordance), and reading it from there would
 * be a circular import. Same reason `constants/pilots.js` holds the list.
 *
 * `featureFlags.js` re-exports all three, so existing call sites are unchanged.
 */

/**
 * Every gated feature is ON at localhost, so flagged surfaces can be worked on
 * without the flag set on your account. Real environments honour the gate.
 */
export const isLocalhost = () =>
  typeof window !== 'undefined' && window.location?.hostname === 'localhost'

/**
 * Staging (`v2-dev.…`) — NOT production.
 *
 * Matched on the `v2-dev` prefix rather than "anything that isn't prod", so a
 * new host can never inherit dev-only affordances by default. Anything gated on
 * this must be something it is safe for a deployed environment to expose.
 */
export const isStaging = () =>
  typeof window !== 'undefined' && /^v2-dev\./.test(window.location?.hostname || '')

/** Localhost or staging — never production. */
export const isNonProdEnv = () => isLocalhost() || isStaging()
